// extracted by mini-css-extract-plugin
export default {"TextBox":"styles_TextBox__nwjOu","quote":"styles_quote__HBeAL"};